import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';

import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import translationEN from "../src/locales/en/translation.json";
import translationFR from "../src/locales/fr/translation.json";

// ⛔️ Prevent iframe embedding
if (window.top !== window.self) {
  // Option 1: Redirect out of iframe
  window.top.location = window.location.href;

  // OR Option 2: Just block (use one of these two)
  // document.body.innerHTML = "<h1>Embedding in iframe is not allowed.</h1>";
  // throw new Error("Blocked from iframe.");
}

i18next.use(HttpApi).use(initReactI18next).init({
  resources: {
    en: { translation: translationEN },
    fr: { translation: translationFR },
  },
  lng: 'en',
  fallbackLng: 'en',
  ns: ['translation'],
  defaultNS: 'translation',
  interpolation: {
    escapeValue: false,
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>    
  </Provider>
);

reportWebVitals();
